import { NgModule } from '@angular/core';
import { ICmsMerchandiserService } from './service/icms-merchandiser-client.service';

@NgModule()
export class ICmsMerchandiserClientModule {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(iCmsMerchandiserService: ICmsMerchandiserService) {}
}
